import React from "react"
import "./Wave.css"

const Wave = () => (
  <svg viewBox='0 0 1150.114 125.391' className={"waveSection"}>
    <defs>
      <style>{".wave{fill:#fff;}"}</style>
    </defs>
    <g transform='translate(0 0)'>
      <g transform='translate(0 0)'>
        <path
          className='wave'
          d='M1150.114,454.661C939.242,503.251,862.416,415,575.845,415S127.959,507.586,0,432.113V540.391H1150.114Z'
          transform='translate(0 -415)'
        />
      </g>
    </g>
  </svg>
);

export default Wave;
